import Home from "@/views/initialPage";

export const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    redirectTo: "/",
    meta: {
      title: "Home",
      keepAlive: true,
    },
  },
  //邮箱填写路由
  {
    path: "/emailCode",
    name: "emailCode",
    component: () => import("../views/emailCode/index.vue"),
    meta: {
      title: " ",
      keepAlive: true,
    },
  },
  //验证验证码的路由
  {
    path: "/verifyCode",
    name: "verifyCode",
    component: () => import("../views/emailCode/children/verifyCode.vue"),
    meta: {
      title: " ",
      keepAlive: true,
    },
  },
  //交易历史列表
  {
    path: "/tradeHistory",
    name: "tradeHistory",
    component: () => import("../views/tradeHistory/list"),
    meta: {
      requireAuth: true,
      title: "nav.routerName_Transactions",
      keepAlive: true,
    },
  },
  // 交易历史详情
  {
    path: "/tradeHistory-BuyDetails",
    name: "buyDetails",
    component: () => import("../views/tradeHistory/details/index"),
    meta: {
      requireAuth: true,
      title: "nav.routerName_Transactions",
      keepAlive: true,
    },
  },
  //支付方式
  {
    path: "/paymentMethod",
    name: "paymentMethod",
    component: () => import("../views/paymentMethod/index.vue"),
    meta: {
      title: "nav.routerName_paymentMethod",
      keepAlive: true,
    },
  },
  // 信用卡确认订单
  {
    path: "/creditCardConfig",
    name: "creditCardConfig",
    component: () => import("../views/payments/creditCard/configPayment.vue"),
    meta: {
      requireAuth: true,
      title: "nav.routerName_creditCardConfig",
      keepAlive: true,
      type: "confirmOrder",
    },
  },
  {
    path: "/otherWays-VA",
    name: "otherWays-VA",
    component: () => import("../views/payments/virtualAccount-opm"),
    meta: {
      requireAuth: true,
      title: "nav.routerName_buyPayment",
      keepAlive: false,
      type: "confirmOrder",
    },
  },
  {
    path: "/otherWayPay",
    name: "otherWayPay",
    component: () => import("../views/payments/e-wallet"),
    meta: {
      requireAuth: true,
      title: "nav.routerName_buyOtherWayPay",
      keepAlive: false,
      type: "confirmOrder",
    },
  },
  {
    path: "/binancePay",
    name: "binancePay",
    component: () => import("../views/payments/binancePay/index.vue"),
    meta: {
      requireAuth: true,
      title: "nav.routerName_buyOtherWayPay",
      keepAlive: false,
      type: "confirmOrder",
    },
  },
  //巴西支付
  {
    path: "/brazilPay",
    name: "BrazilPay",
    component: () => import("../views/payments/brazilPay/index"),
    meta: {
      requireAuth: true,
      title: "nav.routerName_buyOtherWayPay",
      keepAlive: false,
      type: "confirmOrder",
    },
  },
  //巴西支付
  {
    path: "/ArgentinaPay",
    name: "ArgentinaPay",
    component: () => import("../views/payments/ArgentinaPay/index"),
    meta: {
      requireAuth: true,
      title: "nav.routerName_buyOtherWayPay",
      keepAlive: false,
      type: "confirmOrder",
    },
  },
  // 通用支付方式
  {
    path: "/currencyPayment",
    name: "currencyPayment",
    component: () => import("../views/payments/currencyPayment/index"),
    meta: {
      requireAuth: true,
      title: "nav.routerName_buyOtherWayPay",
      keepAlive: false,
      type: "confirmOrder",
    },
  },
  {
    path: "/phpPayment",
    name: "phpPayment",
    component: () => import("../views/payments/phpPayment/index"),
    meta: {
      requireAuth: true,
      title: "nav.routerName_buyOtherWayPay",
      keepAlive: false,
      type: "confirmOrder",
    },
  },
  {
    path: "/PSEWayPay", // pse 哥伦比亚
    name: "PSEWayPay",
    component: () => import("../views/payments/pseWayPay"),
    meta: {
      requireAuth: true,
      title: "nav.routerName_buyOtherWayPay",
      keepAlive: false,
      type: "confirmOrder",
    },
  },
  {
    path: "/pagsmilePay", // pagsmile 厄瓜多尔
    name: "pagsmilePay",
    component: () => import("../views/payments/pagsmilePay"),
    meta: {
      requireAuth: true,
      title: "nav.routerName_buyOtherWayPay",
      keepAlive: false,
    },
  },
  {
    path: "/cashierDesk-bankTransfer",
    name: "cashierDesk-bankTransfer",
    component: () => import("../views/payments/cashierDesk-bankTransfer/index"),
    meta: {
      requireAuth: true,
      title: "nav.routerName_buyOtherWayPay",
      keepAlive: false,
      type: "confirmOrder",
    },
  },
  {
    path: "/cashierDesk-QrCode",
    name: "cashierDesk-QrCode",
    component: () => import("../views/payments/cashierDesk-QrCode/index"),
    meta: {
      requireAuth: true,
      title: "nav.routerName_buyOtherWayPay",
      keepAlive: false,
      type: "confirmOrder",
    },
  },
  //欧元支付
  // {
  //   path: "/euroPay",
  //   name: 'euroPay',
  //   component: () => import('../views/payments/euroPay/index'),
  //   meta: {
  //     requireAuth: true,
  //     title: 'nav.routerName_buyOtherWayPay',
  //     keepAlive: false,
  //     type: "confirmOrder"
  //   }
  // },
  //法币购买nft结果页
  {
    path: "/paymentResult",
    name: "paymentResult",
    component: () => import("../views/resultPage/index"),
    meta: {
      requireAuth: true,
      title: "nav.routerName_paymentResult",
      keepAlive: true,
      type: "payResult",
    },
  },
  //kyc_onfido入口
  {
    path: "/kycVerify",
    name: "KycVerify",
    component: () => import("../views/Kyc/KycVerify.vue"),
    meta: {
      title: "nav.routerName_kycOnfido",
      keepAlive: false,
    },
  },
  //kyc_onfido 审核状态
  {
    path: "/kycStatus",
    name: "KycStatus",
    component: () => import("../views/Kyc/KycVerifyStatus.vue"),
    meta: {
      title: "nav.routerName_kycOnfido",
      keepAlive: false,
    },
  },
  {
    path: "/risk-control/ip-blocked",
    name: "IpBlocked",
    component: () => import("../views/risk-control/IpBlocked.vue"), // 懒加载页面组件
    meta: {
      title: " ",
      keepAlive: false,
    },
  },
];
